import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('anubis', {
  cherry: 'bone_charm',
  lemon: 'black_cat',
  orange: 'underworld_torch',
  bell: 'scales',
  star: 'anubis_wild',
  seven: 'underworld_gate',
  gem: 'soul_gem',
  scatter: 'heart_feather_scatter',
  money: 'anubis_vault',
});

/** Anubis Underworld — GENERATED by scaffoldSlot from
 *  content/slots/anubis.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const ANUBIS_THEME: Theme = {
  id: 'anubis',
  name: 'Anubis Underworld',
  palette: {
    accent: 0x6a5ac0,
    secondary: 0xe0a52e,
    warm: 0xffd98a,
    frameFill: 0x161028,
    bgGradientTop: 0x1a1430,
    bgGradientBottom: 0x07050f,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Bone Charm', glyph: '🦴', tint: 0xE8E0C8, weight: 5, textureAlias: 'anubis:cherry',
        winVideoAlias: 'anubis:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Black Cat', glyph: '🐈‍⬛', tint: 0x6A5AC0, weight: 5, textureAlias: 'anubis:lemon',
        winVideoAlias: 'anubis:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Torch', glyph: '🔥', tint: 0xE87B3A, weight: 4, textureAlias: 'anubis:orange',
        winVideoAlias: 'anubis:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Scales', glyph: '⚖️', tint: 0xE0A52E, weight: 3, textureAlias: 'anubis:bell',
        winVideoAlias: 'anubis:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Anubis', glyph: '🐺', tint: 0xFFE49A, weight: 2, textureAlias: 'anubis:star',
        winVideoAlias: 'anubis:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Underworld Gate', glyph: '🚪', tint: 0x6A5AC0, weight: 2, textureAlias: 'anubis:seven',
        winVideoAlias: 'anubis:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Soul Gem', glyph: '💜', tint: 0x6A5AC0, weight: 2.5, textureAlias: 'anubis:gem',
        winVideoAlias: 'anubis:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'The Weighing', glyph: '❤️', tint: 0xE0A52E, weight: 0.5, textureAlias: 'anubis:scatter',
        winVideoAlias: 'anubis:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Anubis Vault', glyph: '🪙', tint: 0xe0a52e, weight: 1, textureAlias: 'anubis:money',
        winVideoAlias: 'anubis:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x161028, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x6a5ac0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x161028, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe0a52e, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x6a5ac0, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x161028, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x6a5ac0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xffd98a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'anubis:bg', path: 'environment/anubis.png' },
      columnBackground: { alias: 'anubis:column_bg', path: 'reel/anubis_column_bg.png' },
      border: { alias: 'anubis:border', path: 'brand/border_egypt.png' },
    },
  },
};
